import { eachMonthOfInterval, subMonths } from "date-fns"
import { PROPOSTA_OPTIONS } from "src/components/projetos/constants"
import { TENSAO_SAIDA_OPTIONS } from "src/components/projetos/hibrido/FormClienteHibrido/containers/TensaoSaidaInput"
import { TIPO_LIGACAO_OPTIONS } from "src/components/projetos/hibrido/FormClienteHibrido/containers/TipoLigacaoInput"
import { FormProjetoHibridoLoadingsType, FormProjetoHibridoModalsType, FormProjetoHibridoType, FormProjetoHibridoValidationsType } from "./hibrido.types"

export const DEFAULT_PROJETO_HIBRIDO_VALIDATIONS: FormProjetoHibridoValidationsType = {
  tipo_bateria: { status: true, helper: '' },
  modulo: { status: true, helper: '' },
  estrutura: { status: true, helper: '' },
  fileiras: { status: true, helper: '' }
}

export const DEFAULT_PROJETO_HIBRIDO_MODALS: FormProjetoHibridoModalsType = {
  equipamentos: false,
  drawerInformacoes: false,
  potencia_desejada: false,
}

export const DEFAULT_PROJETO_HIBRIDO_LOADINGS: FormProjetoHibridoLoadingsType = {
  listagemEstruturas: false,
  calculoModulos: false,
  listagemModulos: false,
}

export const DEFAULT_PROJETO_HIBRIDO: FormProjetoHibridoType = {
  id: 0,
  alterou_modulo: false,
  listagem_baterias_status: false,
  taxa_descarga: null,
  tipo_ligacao: TIPO_LIGACAO_OPTIONS[0],
  modo_potencia: null,
  potencia_desejada_w: 0,
  potencia_desejada_kw: 0,
  regioes: [],
  codigo_venda: null,
  consumo_data_inicial: subMonths(new Date(), 12),
  consumo_data_final: subMonths(new Date(), 1),
  consumo_meses: eachMonthOfInterval({ start: subMonths(new Date(), 12), end: subMonths(new Date(), 1)}).map(day => {
    return {
      day: day.toISOString(),
      value: 0
    }
  }),
  servico: null,
  titulo: null,
  segmento: 'distribuicao_ongrid',
  reativar: false,
  recalcular: false,
  valor: 0.0,
  valor_servico: 0.0,
  valor_servico_pis_cofins: 0.0,
  cliente_proposta: "",
  email_proposta: '',
  distribuidor_id: 0,
  distribuidor: null,
  cidade_id: 0,
  cidade: undefined,
  revenda_id: null,
  revenda: null,
  modulo_selecionado: null,
  modulos: [],
  inversores: [],
  acessorios: [],
  resultado_calculos: null,
  tipo: 'dimensionado',
  recebe_servico: false,
  latitude: 0,
  longitude: 0,
  fileiras: [{
    fileiras: 1,
    posicao_modulo: null,
    quantidade_modulos: 0,
    tipo_estrutura: null,
  }],
  estruturas_calculadas: [],
  isEdit: false,
  vendedor_interno: undefined,
  tipo_bateria: null,
  clonar_projeto: false,
  tensao_saida: TENSAO_SAIDA_OPTIONS[0],
  estado_id: "",
  estado: undefined,
  estado_original: undefined,
  isTrocaUf: false,

  estruturas_ativas: [],
  todas_estruturas: [],
  estruturas_retrato: [],
  estruturas_paisagem: [],

  cargas_prioritarias: [],
  total_carga_equipamentos_w: 0,
  total_carga_equipamentos_kw: 0,

  solucao_calculada: {
      baterias: [],
      inversores: [],
  },

  baterias: [],
  valor_minimo_servico: 0,
  tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null,
  justificativa_valor_servico: '',
  old_componentes_edicao: [],
  old_estado_id: '',
  sugestoes: {
    acessorios: [],
  },
}
